// extracted by mini-css-extract-plugin
export default {"network":"Network_network__48qY8","network-img":"Network_network-img__s1UcD","network-list":"Network_network-list__hnXRy","list-item":"Network_list-item__sNwiC"};